import { render, staticRenderFns } from "./layerDetailDialog.vue?vue&type=template&id=8f22cfdc"
import script from "./layerDetailDialog.vue?vue&type=script&lang=js"
export * from "./layerDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./layerDetailDialog.vue?vue&type=style&index=0&id=8f22cfdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports